export default "__VITE_ASSET__CODGVP2R__"